import { render, staticRenderFns } from "./Hair4.vue?vue&type=template&id=6ee01e34&"
import script from "./Hair4.vue?vue&type=script&lang=js&"
export * from "./Hair4.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports